module.exports = __webpack_public_path__ + "img/gana_c.568cf2a.png";